'use strict';

import $ from 'jquery';
import 'select2';
import Swal from 'sweetalert2';
import { recaptchaUpdater } from '../../modules/recaptcha';
import { vp } from '../../modules/select';

const profilesQuestions = {
  settings: {
    _token: $('meta[name="csrf-token"]').attr('content'),
    $vps: $('#js-vicepresident'),
    $superintendent: $('.js-superintendent'),
    $regionals: $('.js-regionals'),
  },
  init() {
    recaptchaUpdater('profile');
    vp();

    $('.js-worked')
      .select2({
        placeholder: 'Selecione',
        theme: 'classic',
        multiple: true,
      })
      .on('select2:select', function (e) {
        if ($('.js-worked').val().includes('Não')) {
          $(this).val(e.params.data.text).trigger('change');
        }
      });

    $('.js-interest').select2({
      placeholder: 'Selecione',
      theme: 'classic',
      multiple: true,
    });

    $('#form-signin').on('submit', function () {
      if ($('#enrollment').val() == '') {
        Swal.fire({
          icon: 'error',
          title: 'Atenção!',
          text: 'Preencha os campos corretamente',
        });
        return false;
      }
    });
  },
};

const _this = profilesQuestions,
  s = _this.settings;

export default _this;
